
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["cross-color",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25.407","height":"25.407","viewBox":"0 0 25.407 25.407"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Gruppe 514","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3"}},[_c('path',{attrs:{"data-name":"Linie 6","d":"M2.121 2.121l21.165 21.165"}}),_c('path',{attrs:{"data-name":"Linie 7","d":"M23.286 2.121L2.121 23.286"}})])])
          )
        }
      }
    